import PropTypes from 'prop-types'
import React from 'react'
import IconError from '@/checkout-instore-legacy/components/Commons/IconError'
import { CSSTransitionGroup } from '../CSSTransitionGroup'

export default function TopMessage({
  isVisible,
  message,
  type,
  onClose,
  children,
}) {
  let typeClass = ''
  let iconComponent = null
  switch (type) {
    case 'info':
      typeClass = 'white bg-action-primary'
      break
    case 'warning':
      typeClass = 'gold bg-warning'
      break
    case 'error':
      typeClass = 'dark-red bg-danger'
      iconComponent = <IconError width={18} height={18} fill="#b12416" />
      break
    default:
      typeClass = 'green bg-success'
      break
  }

  return (
    <CSSTransitionGroup
      transitionName="height"
      transitionEnterTimeout={200}
      transitionLeaveTimeout={200}
    >
      {isVisible ? (
        <div
          className={`flex justify-center items-center pa3 pv4-ns tc f6 f5-ns bb b--black-20 ${typeClass}`}
        >
          <div className="flex-none mr3">{iconComponent}</div>
          <div data-cy="cart-top-message" className="flex-none lh-copy">
            {message || children}
          </div>
          {onClose ? (
            <div className="flex-none pa5 f3" onClick={onClose}>
              <i className="fa fa-cancel" />
            </div>
          ) : null}
        </div>
      ) : null}
    </CSSTransitionGroup>
  )
}

TopMessage.propTypes = {
  isVisible: PropTypes.bool,
  children: PropTypes.any,
  message: PropTypes.string,
  type: PropTypes.string,
  onClose: PropTypes.func,
}
